import { Injectable } from '@angular/core';

import { CalculationApiService } from './calculationApiService';
import { SessionService } from '../session-service.service';

@Injectable({
  providedIn: 'root',
})

export class CalculationGgService {
  constructor(
    private calculationApiService: CalculationApiService,
    private sessionService: SessionService,
  ) {}

  requestCalculateGG(): void {
    const requestDTO = this.sessionService.getCallculationRequest();
    this.calculationApiService
      .requestCalculation(requestDTO)
      .subscribe((response) => {
        if (response?.results != null && response.results.length > 0) {
          const premiums = response.results[0].premiums[0];
          this.sessionService.setCalculationResponse(premiums);
        }
      });
  }
}
